import { API_URLS, PROMO_URLS } from '../helpers/api/API_URLS';
import { basicGET, basicJSONPOST } from '../helpers/api/fetchParams';

export async function getSendGridTemplates() {
    var token = localStorage.getItem("token");
    const response = await fetch(PROMO_URLS.template, basicGET(token))
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();    
    const arr = [];
    for (var i = data.length - 1; i >= 0; i--) {
        arr.push(
            { "name" : data[i].name, "value" : data[i].id },
        );
    }
    return arr;
}

export async function sendEmailTest(body) {
    var token = localStorage.getItem("token");
    const response = await fetch(API_URLS.CRM+"lead/event", basicJSONPOST(token, body));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}


// WEBPACK FOOTER //
// ./src/data/serviceSendgrid.js